import Cards from '@/components/Cards';
import { WithDefaultLayout } from '@/components/DefautLayout'
import RegistrationButton from '@/components/RegistrationButton';
import TermCondition from '@/components/TermCondition';
import TitleTemp from '@/components/TitleTemp';
import Workshop from '@/components/Workshop';
import { Page } from '@/types/Page'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'


const Home = () => {
    return (
        <div className="relative mt-20 lg:mt-24 md:mt-12">
            <img alt="indexpict" className="w-full min-h-screen lg:min-h-0 lg:h-auto md:relative lg:relative flex bg-center mx-auto" src="/images/program-bg.webp" />
            <div className="absolute inset-0 bg-gray-900 opacity-70"></div>
            <div className="absolute inset-0 flex flex-col justify-center items-center text-white">
                <h1 className=" text-base lg:text-4xl mb-10">IIT Challenge Program</h1>
                <div className="flex items-center mb-10">
                    <FontAwesomeIcon icon={faCalendarDays} className='mr-2' style={{ fontSize: "1.25rem" }} />
                    <h1 className="text-base lg:text-xl" style={{ textShadow: "1px 1px 1px black" }}>05 October 2024</h1>
                </div>
                <h1 className=" text-base lg:text-2xl mb-10" style={{ textShadow: "1px 1px 1px black" }}> At Universitas Kristen Krida Wacana (UKRIDA)</h1>
                <div className="p-10 rounded-md flex flex-col justify-center">
                    <RegistrationButton />
                </div>
            </div>
        </div>
    );
}

const ChooseCategory = () => {
    return (
        <>
            <div className="col-span-3">
                <TitleTemp name={"Choose Your Category"} />
            </div>
            <div className="max-w-screen-lg px-8 lg:px-0 mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <Cards/>
                </div>

            </div>
        </>
    )
}

const WorkshopProgram = () => {
    return (
        <div
            className="bg-center bg-cover mt-24"
            style={{
                backgroundImage: 'url("/images/workshop/workshop-bg.webp")',
                minHeight: '700px',
            }}
        >
            <h2 className="text-2xl md:text-4xl font-semibold text-center mb-8 mt-8 text-white py-8">Workshop</h2>
            <Workshop />
        </div>
    );
}

const Render = () => {
    return (
        <div>
            {Home()}
            <div className="container mx-auto">
                {ChooseCategory()}
            </div>
            {WorkshopProgram()}
            <TermCondition />

        </div>
    );
}

const iitProgram: Page = () => {
    return (
        <div>
            {Render()}
        </div>
    )
}

iitProgram.layout = WithDefaultLayout;
export default iitProgram
